import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sm:pl-0 md:pl-4 lg:pl-52 pt-14 mx-auto w-full" }
const _hoisted_2 = { class: "py-6 sm:py-8 md:py-10" }
const _hoisted_3 = { class: "px-3 sm:px-4 md:px-6 lg:px-8" }

import { ref, onMounted } from "vue";
import AppNavbar from "@/components/app-navbar.vue";
import AppSidebar from "@/components/app-sidebar.vue";
import { useProfileStore } from "@/stores/useProfileStore";

// Reference to sidebar component

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const sidebar = ref<InstanceType<typeof AppSidebar> | null>(null);

// Profile store instance
const profileStore = useProfileStore();

// Toggle sidebar visibility
const toggleSidebar = () => {
  if (sidebar.value) {
    sidebar.value.sidebarOpen = !sidebar.value.sidebarOpen;
  }
};

// Fetch profile and handle errors without locking screen
onMounted(async () => {
  try {
    await profileStore.fetchProfile();
  } catch (error) {
    console.error("Error fetching profile:", error);
    alert(
      "Erro ao carregar dados do perfil. Por favor, contate o administrador."
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppNavbar, { onToggleSidebar: toggleSidebar }),
    _createVNode(AppSidebar, {
      ref_key: "sidebar",
      ref: sidebar
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ], 64))
}
}

})